export default __webpack_public_path__ + "static/media/tickCircle.e95f91d6.svg";